import { action } from 'satcheljs';
import type EventScope from 'owa-service/lib/contract/EventScope';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type { ClientItemId } from 'owa-client-ids';

export const forwardSurfaceEvent = action(
    'forwardSurfaceEvent',
    (
        event: CalendarEvent,
        eventScope: EventScope,
        openEventDetails: (id: ClientItemId) => void
    ) => ({
        event,
        eventScope,
        openEventDetails,
    })
);
